import { ReactElement } from 'react';
import { Stack, DialogContentText } from '@mui/material';

import { useDialogIntegrationAssignWarehousesContext } from '../../Context';

const DialogIntegrationAssignWarehousesEmptyState = (): ReactElement => {
  const { errorStockLocations } = useDialogIntegrationAssignWarehousesContext();

  return (
    <Stack spacing={2} flex={1} justifyContent="center" alignItems="center">
      <DialogContentText color="text.primary">
        {errorStockLocations ?? 'No se encontraron depósitos de origen'}
      </DialogContentText>
    </Stack>
  );
};

export default DialogIntegrationAssignWarehousesEmptyState;
